import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

import { countries } from '@/models/country.model';
import {
  DataTable,
  nameRules,
  dataRules,
  DataTableLegend,
} from '@/models/data-table.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { DataTablesActions, DataTablesState } from '@/stores/data-tables.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableForm',
  props: {
  data: {
    type: Object as PropType<DataTable>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { ds: DataTablesState }>();
const defaults = computed<DataTable[]>(() => store.state.ds.defaults);
const legends = computed<DataTableLegend[]>(() => store.state.ds.legends);

const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const dataTable = ref<DataTable>({
  id: NEW_ID,
  name: '',
  country: 'nl',
  data: '{}',
});

const legend = computed<DataTableLegend>(
  () =>
    legends.value.find((v) => v.name === dataTable.value.name) || {
      name: '',
      data: {},
    },
);

const action = computed<string>(() =>
  dataTable.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveDataTable = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (dataTable.value.id === NEW_ID) {
      success = await store.dispatch(
        DataTablesActions.AddDataTable,
        dataTable.value,
      );
    } else {
      success = await store.dispatch(
        DataTablesActions.UpdateDataTable,
        dataTable.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved Data Table',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(DataTablesActions.GetDataTables);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save Data Table',
      type: 'error',
    });
  }
};

onMounted(() => {
  if (props.data) {
    Object.assign(dataTable.value, {
      ...props.data,
      data: JSON.stringify(props.data.data, null, 2),
    });
  }

  store.dispatch(DataTablesActions.GetDataTablesDefaults);
  store.dispatch(DataTablesActions.GetDataTablesLegends);
});

const useData = (d: string) => {
  Object.assign(dataTable.value, {
    data: JSON.stringify(d, null, 2),
  });
};

const removeLabel = async () => {
  if (
    dataTable.value &&
    dataTable.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "Data Table"?')
  ) {
    store.dispatch(DataTablesActions.DeleteDataTable, dataTable.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveDataTable, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(action.value)) + " a data table", 1),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: dataTable.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataTable.value.name) = $event)),
                    rules: _unref(nameRules),
                    label: "Name",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "mx-auto",
                cols: "5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: dataTable.value.country,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataTable.value.country) = $event)),
                    items: _unref(countries),
                    label: "Country",
                    "item-title": "text",
                    "item-value": "value",
                    "hide-details": true
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea, {
                    modelValue: dataTable.value.data,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataTable.value.data) = $event)),
                    required: "",
                    rows: "20",
                    rules: _unref(dataRules)
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaults.value, (def) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                      density: "compact",
                      class: "mb-2",
                      type: "button",
                      onClick: ($event: any) => (useData(def.data)),
                      block: "",
                      color: "warning",
                      key: def.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Use " + _toDisplayString(def.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (legend.value.name && dataTable.value.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Legend", -1)),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(legend.value.data || {}), (key) => {
                      return (_openBlock(), _createBlock(_component_v_col, { key: key }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(key), 1),
                          _createElementVNode("pre", null, _toDisplayString(JSON.stringify(legend.value.data[key], null, 2)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    onClick: removeLabel,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})